export default __webpack_public_path__ + "static/media/Vitara.77e9f8b7.png";